import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { getCheckDupleEmail, getCheckDupleLoginId } from "components/axios/joinAxios";
import { deleteUsers, getUsersByQuery, patchUsers, postUsers } from "components/axios/userAxios";
import ManagementCompanyZoneSettingLayer from "components/layer/ManagementCompanyZoneSettingLayer";
import { modals } from "components/modals/Modals";
import useModals from "components/modals/useModal";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import { useEnumApi } from "contexts/EnumApiContext";
import { ROLE } from "data/data";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";


const CompanyModifyUser = ({company, loginInfo}) => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
                // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const { control:userControl, register:userRegister, handleSubmit:userHandleSubmit
        , reset:userReset, setValue:userSetValue, formState : {isDirty:userIsDirty, errors:userErrors } } = useForm({});
    const { control:userUpdateControl, register:userUpdateRegister, handleSubmit:userUpdateHandleSubmit
        , reset:userUpdateReset, setValue:userUpdateSetValue, formState : {isDirty:userUpdateIsDirty, errors:userUpdateErrors } } = useForm({});
    
    const emailRegEx = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
    // const passwordRegEx = /^[A-Za-z0-9]{8,20}$/; // 영문숫자8-20자
    const passwordRegEx = /^\S{8,20}$/; // 설명: 공백문자 없이 8~20자 (공백 포함 불허)

    const [isLoading, setIsLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [zonesByUser, setZonesByUser] = useState(null);
    const [checkZonesByUser, setCheckZonesByUser] = useState(null);
    const [isUserIdCheck, setIsUserIdCheck] = useState(false);
    const [isEmailCheck, setIsEmailCheck] = useState(false);
    const [userId, setUserId] = useState('');
    const [email, setEmail] = useState('');
    const [userModifyView, setUserModifyView] = useState([]);

    useEffect(() => {
        if (company && !isLoading) {
            // console.log(company)
            // console.log({"company.id":company.id, page:0, size : 100})
            getUsersByQuery({"company.id":company.id, page:0, size : 100}).then((res) => {
                // console.log(res)
                setUsers(res._embedded?.users)

                let arr = Array.from({length : res.length},() => false);
                setUserModifyView(arr);

                setIsLoading(true)
            })
        }
    }, [company, isLoading]);

    const roleTypes = useMemo(()=>{
        return getEnumValueByEnumName('RoleType').filter((role)=>(role.code === ROLE.AD.code || role.code === ROLE.WK.code || role.code === ROLE.MO.code))
    },[getEnumValueByEnumName])
    
    const setUserZones = (userId, zones) => {
        setZonesByUser({["userId"+userId] : zones})
    }
    
    const userOnSubmit = (data) => {
        if (!isUserIdCheck) {
            handleAlertClick(t('message.common.alert.id.duplication.check'));
            return;
        }

        if (!isEmailCheck) {
            handleAlertClick(t('message.common.alert.email.duplication.check'));
            return;
        }

        let dto = {
            company : {id : company.id},
            loginId: data.loginId,
            password : data.userPassword,
            name: data.userName,
            email: data.userEmail,
            contact: data.userContact,
            role: data.role,
            loginActiveStatus : 'ACT'
        };
        
        console.log(dto)
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                console.log('user add')
                postUsers(dto).then(()=>{
                    handleAlertClick(t('message.common.alert.add.done'));
                    userReset();
                    setIsLoading(false);
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
            },
            onClose : () => {
            },
            message: t('message.common.alert.add.question'),
        });
    }

    const dupleCheckId = () => {
        if (!userId) {
            handleAlertClick(t('message.common.alert.id.input'));
            return;
        }

        getCheckDupleLoginId({loginId:userId}).then((data)=>{
            setIsUserIdCheck(!data);
            if (data) {
                handleAlertClick(t('message.common.alert.id.use.other.id.input'));
            } else {
                handleAlertClick(t('message.common.alert.id.available'));
            }
        }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
        })
    }

    const dupleCheckEmail = () => {
        if (!email) {
            handleAlertClick(t('message.common.error.text.email.input'));
            return;
        }

        getCheckDupleEmail({email}).then((data)=>{
            setIsEmailCheck(!data);
            if (data) {
                handleAlertClick(t('message.common.alert.email.use.other.email.input'));
            } else {
                handleAlertClick(t('message.common.alert.email.available'));
            }
        }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
        })
    }

    const userUpdateOnSubmit = (data) => {
        // console.log("data", data);
        // console.log("users", users);
        // console.log("zonesByUser" , zonesByUser);
        // console.log("checkZonesByUser" , checkZonesByUser);
        // console.log(zonesByUser && zonesByUser["userId"+data.id])
        
        let body = {
            id : data.id,
            password : data.userPassword,
            name : data.userName,
            email : data.userEmail,
            contact : data.userContact,
            loginActiveStatus : data.status
        }
        // zones: [{id:2, company:{id:1, name: '백운'}, name:'공장'}]
        let zoneList = [];
        if (zonesByUser && zonesByUser["userId"+data.id] && zonesByUser["userId"+data.id].length > 0) {
            zonesByUser["userId"+data.id].map((zone, i)=>{
                // console.log(Object.values(checkZonesByUser).flat().some(arr => arr.endsWith(zone)))
                // console.log(Object.values(checkZonesByUser).flat())
                if (Object.values(checkZonesByUser).flat().some(arr => arr.endsWith(zone))) {
                    const zoneArray = Object.values(checkZonesByUser).flat();
                    const filtered = 
                        zoneArray.filter((arr) =>
                            arr.endsWith(zone)
                        )
                    ;
                    // console.log(filtered);
                    if (filtered) {
                        zoneList.push({id:filtered[0].substring(0,filtered[0].indexOf('-'))})
                    } else {
                        zoneList.push({zone:{id:zone}})
                    }
                } else {
                    zoneList.push({zone:{id:zone}})
                }
            })
        }
        
        // console.log(zoneList)
        if (zoneList && zoneList.length > 0) {
            body.equipmentZoneManagers = zoneList;
        } else {
            body.equipmentZoneManagers = [];
        }
        console.log(body)

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                console.log('user modify')
                patchUsers(body).then((res)=>{
                    handleAlertClick(t('message.common.alert.modify.done'));
                    setIsLoading(false);
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
            },
            onClose : () => {
            },
            message: t('message.common.alert.modify.question'),
        });
    }

    const handleUserDeleteBtnClick = (param) => {
        console.log(param)

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                console.log('user delete')
                deleteUsers(param).then(()=>{
                    handleAlertClick(t('message.common.alert.delete'));
                    setIsLoading(false);
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
            },
            onClose : () => {
            },
            message: t('message.common.alert.delete.question'),
        });
    }

    if (isLoading) {
        return (
        <div>
            <div className="mro_search">
                <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.title.user.list')}</h6>
            </div>
            <TableContainer>
            <form onSubmit={userHandleSubmit(userOnSubmit)}>
                <Table aria-label="simple table" className="same_width">
                <TableHead>
                    <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.authority')}</TableCell>
                    <TableCell className="th" align="center">{t('login.id')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.password')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.manager.name')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.email')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.company.contact')}</TableCell>
                    {/* <TableCell className="th" align="center">{t('message.common.subtitle.worker.certification.number')}</TableCell> */}
                    {company.type === 'MNT'  && <TableCell className="th" align="center">{t('message.common.subtitle.manager.zone')}</TableCell>}
                    <TableCell className="th" align="center" style={{width:'80px'}}>{t('message.common.subtitle.status')}</TableCell>
                    {(loginInfo.role === ROLE.SA.code || (loginInfo.role === ROLE.AD.code && loginInfo.company?.id === company.id)) && <TableCell className="th" align="center" style={{width:'150px'}}></TableCell>}
                    </TableRow>
                </TableHead>
    
                <TableBody>
                { users?.length > 0 && users?.map(function(user, i) {
                    if (userModifyView[i] && (loginInfo.role === ROLE.SA.code || (loginInfo.role === ROLE.AD.code && loginInfo.company?.id === company.id))) {  // 수정폼
                    return (  
                  <TableRow key={i}>
                    <TableCell>
                      <input type="hidden" {...userUpdateRegister("id")} value={user.id} />
                      <Controller
                          control={userUpdateControl}
                          name="role"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%', margin:"8px" , pointerEvents: 'none'}}
                              label={t('message.common.subtitle.authority')}
                              register={userUpdateRegister}
                              name={name}
                              requiredMessage={t('message.common.error.text.authority.select')}
                              defaultValue={user.role || ''}
                              list={roleTypes}
                          />
                          )}
                          rules={{ required: true }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField id="loginId" 
                        //   aria-invalid={!userUpdateIsDirty ? undefined : userUpdateErrors.loginId ? "true" : "false"}
                          defaultValue={user.loginId || ''}
                          disabled
                          key={user.loginId}
                          {...userUpdateRegister("loginId", {
                            //   required : t('message.common.error.text.id.input')
                          })} 
                          sx={{ m: 1, minWidth: '80%' }} 
                      />
                      {/* {userUpdateErrors.loginId && <small role="alert"><br></br>{userUpdateErrors.loginId.message}</small>} */}
                    </TableCell>
                    <TableCell>
                      <TextField id="userPassword" 
                          aria-invalid={!userUpdateIsDirty ? undefined : userUpdateErrors.userPassword ? "true" : "false"}
                        //   key={'userPassword'}
                          {...userUpdateRegister("userPassword", {
                            //   required : t('message.common.error.text.password.input'),
                              pattern : {
                                  value : passwordRegEx,
                                  message : "invalid password"
                              }
                          })}
                          type="password"
                          autoComplete="new-password"
                          sx={{ m: 1, minWidth: '90%' }} 
                      />
                      {userUpdateErrors.userPassword && <small role="alert"><br></br>{userUpdateErrors.userPassword.message}</small>}
                    </TableCell>
                    <TableCell>
                      <TextField id="userName" 
                          aria-invalid={!userUpdateIsDirty ? undefined : userUpdateErrors.userName ? "true" : "false"}
                          defaultValue={user.name || ''}
                          key={`userName${i}`}
                          {...userUpdateRegister("userName", {
                              required : t('message.common.error.text.manager.name.input')
                          })} 
                        //   onChange={(e)=>{console.log(e.target.value)}}
                          sx={{ m: 1, minWidth: '90%' }} 
                      />
                      {userUpdateErrors.userName && <small role="alert"><br></br>{userUpdateErrors.userName.message}</small>}
                    </TableCell>
                    <TableCell>
                      <TextField id="userEmail" 
                          key={`userEmail${i}`}
                          // aria-invalid={!userUpdateIsDirty ? undefined : userUpdateErrors.userEmail ? "true" : "false"}
                          {...userUpdateRegister("userEmail", {
                              // required : t('message.common.error.text.email.input'),
                              pattern : {
                                value : emailRegEx,
                                message : "invalid email address"
                              }
                          })} 
                        //   onChange={(e)=>{console.log(e.target.value)}}
                          defaultValue={user.email || ''}
                          sx={{ m: 1, width: '80%' }}
                          onClick={()=>{setIsEmailCheck(false);}}
                          onChange={(event) => {setEmail(event.target.value); setIsEmailCheck(false);}}
                      />
                      <img src={`${process.env.PUBLIC_URL}/img/icon/circle.png`} style={{marginTop: '15px', cursor: 'pointer'}} onClick={()=>{dupleCheckEmail()}} />
                      {userUpdateErrors.userEmail && <small role="alert" style={{whiteSpace:"pre-wrap"}}><br></br>{userUpdateErrors.userEmail.message}</small>}
                    </TableCell>
                    <TableCell>
                      <TextField id="userContact" 
                          // aria-invalid={!userUpdateIsDirty ? undefined : userUpdateErrors.userContact ? "true" : "false"}
                          defaultValue={user.contact || ''}
                          key={`userContact${i}`}
                          {...userUpdateRegister("userContact", {
                              // required : t('message.common.error.text.manager.contact.input')
                          })} 
                          sx={{ m: 1, minWidth: '90%' }} 
                      />
                      {/* {userUpdateErrors.userContact && <small role="alert"><br></br>{userUpdateErrors.userContact.message}</small>} */}
                    </TableCell>
                    {/* <TableCell>
                      <TextField id="userCertificationNumber" 
                          defaultValue={user.certificationNumber || ''}
                          key={`userCertificationNumber${i}`}
                          {...userUpdateRegister("userCertificationNumber", {
                          })} 
                          sx={{ m: 1, minWidth: '90%' }} 
                      />
                    </TableCell> */}
                    {company.type === 'MNT' && 
                    <TableCell>
                        {user.role === ROLE.WK.code &&
                        <ManagementCompanyZoneSettingLayer companyId={company.id} userId={user.id} checkZones={zonesByUser} setUserZones={setUserZones} />
                        }
                    </TableCell>
                    }
                    <TableCell>
                      <Controller
                          control={userUpdateControl}
                          name="status"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%', margin:"8px" }}
                              label={t('message.common.subtitle.status')}
                              register={userUpdateRegister}
                              name={name}
                              requiredMessage={t('message.common.error.text.status.select')}
                              defaultValue={user.loginActiveStatus || ''}
                              list={getEnumValueByEnumName('ActiveStatus')}
                          />
                          )}
                          rules={{ required: true }}
                      />
                      {userUpdateErrors.status && <small role="alert"><br></br>{userUpdateErrors.status.message}</small>}
                    </TableCell>
                    <TableCell align='right'>
                      <Button variant="outlined" color="success" className="small_btn" type="button"
                        onClick={userUpdateHandleSubmit(userUpdateOnSubmit)}
                      >{t('message.common.btn.modify')}</Button>&nbsp;
                      <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                        let arr = Array.from({length : users.length},() => false);
                        arr[i] = false;
                        setUserModifyView(arr);
                        setZonesByUser(null);
                        setCheckZonesByUser(null);
                        userUpdateReset();
                      }}>{t('message.common.btn.cancel')}</Button>
                    </TableCell>
                  </TableRow>
                    )
                    } else {   // 목록
                        return (
                    <TableRow key={i}>
                        <TableCell>{roleTypes.find(role=>role.code === user.role)?.title || ''}</TableCell>
                        <TableCell>{user.loginId || ''}</TableCell>
                        <TableCell>{'***'}</TableCell>
                        <TableCell>{user.name || ''}</TableCell>
                        <TableCell>{user.email || ''}</TableCell>
                        <TableCell>{user.contact || ''}</TableCell>
                        {/* <TableCell>{user.certificationNumber || ''}</TableCell> */}
                        {company.type === 'MNT'  && 
                        <TableCell>
                            {user.role === 'WK' ?
                                user.equipmentZoneManagers && user.equipmentZoneManagers.map((zone, k)=>{
                                // if (zone.company?.id === company.id) {
                                    return (<React.Fragment key={k}>{zone.zone.name || ''}{k<user.equipmentZoneManagers.length-1 && <br/>}</React.Fragment>)
                                // } else {
                                //     return (<React.Fragment key={k}>{zone.company.name || ''} &gt; {zone.name || ''}{k<user.equipmentZoneManagers.length-1 && <br/>}</React.Fragment>)
                                // }
                                })
                            : '-'
                            }
                        </TableCell>
                        }
                        <TableCell>{getEnumValueByEnumNameAndCode('ActiveStatus', user.loginActiveStatus)?.[0]?.title || ''}</TableCell>
                        {(loginInfo.role === ROLE.SA.code || (loginInfo.role === ROLE.AD.code && loginInfo.company?.id === company.id)) && 
                        <TableCell>
                            <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                                let arr = Array.from({length : users.length},() => false);
                                arr[i] = true;
                                setUserModifyView(arr);
                                console.log(user.equipmentZoneManagers.map((m)=>m.zone.id))
                                setZonesByUser({["userId"+user.id] : user.equipmentZoneManagers.map((m)=>m.zone.id)});
                                setCheckZonesByUser({["userId"+user.id] : user.equipmentZoneManagers.map((m)=>m.id+'-'+m.zone.id)})
                                userUpdateReset();
                            }}>{t('message.common.btn.modify')}</Button>&nbsp;
                            <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                                handleUserDeleteBtnClick(user.id);
                            }}>{t('message.common.btn.delete')}</Button>
                        </TableCell>
                        }
                    </TableRow>
                        )
                    }
                })}
                </TableBody>
                {/* 등록 */}
                {(loginInfo.role === ROLE.SA.code || (loginInfo.role === ROLE.AD.code && loginInfo.company?.id === company.id)) && 
                <tfoot>
                    <tr>
                        <td>
                            <Controller
                                control={userControl}
                                name="role"
                                render={({ field: {name} }) => (
                                <CustomFormEnumSelect
                                    style={{ minWidth: '90%', margin:"8px" }}
                                    label={t('message.common.subtitle.authority')}
                                    register={userRegister}
                                    name={name}
                                    requiredMessage={t('message.common.error.text.authority.select')}
                                    defaultValue={''}
                                    list={roleTypes}
                                />
                                )}
                                rules={{ required: true }}
                            />
                            {userErrors.role && <small role="alert"><br></br>{userErrors.role.message}</small>}
                        </td>
                        <td>
                            <TextField id="loginId" 
                                aria-invalid={!userIsDirty ? undefined : userErrors.loginId ? "true" : "false"}
                                defaultValue={''}
                                key={'loginId'}
                                {...userRegister("loginId", {
                                    required : t('message.common.error.text.id.input')
                                })} 
                                sx={{ m: 1, width: '80%' }} 
                                autoComplete="new-loginId"
                                onClick={()=>{setIsUserIdCheck(false);}}
                                onChange={(event) => {setUserId(event.target.value); setIsUserIdCheck(false);}}
                            />
                            <img src={`${process.env.PUBLIC_URL}/img/icon/circle.png`} style={{marginTop: '15px', cursor: 'pointer'}} onClick={()=>{dupleCheckId()}} />
                            {userErrors.loginId && <small role="alert"><br></br>{userErrors.loginId.message}</small>}
                        </td>
                        <td>
                            <TextField id="userPassword" 
                                aria-invalid={!userIsDirty ? undefined : userErrors.userPassword ? "true" : "false"}
                                defaultValue={''}
                                key={'userPassword'}
                                {...userRegister("userPassword", {
                                    required : t('message.common.error.text.password.input'),
                                    pattern : {
                                        value : passwordRegEx,
                                        message : "invalid password"
                                    }
                                })}
                                type="password"
                                autoComplete="new-password"
                                sx={{ m: 1, minWidth: '90%' }} 
                            />
                            {userErrors.userPassword && <small role="alert"><br></br>{userErrors.userPassword.message}</small>}
                        </td>
                        <td>
                            <TextField id="userName" 
                                aria-invalid={!userIsDirty ? undefined : userErrors.userName ? "true" : "false"}
                                defaultValue={''}
                                key={'userName'}
                                {...userRegister("userName", {
                                    required : t('message.common.error.text.manager.name.input')
                                })} 
                                // onChange={(e)=>{console.log(e.target.value)}}
                                sx={{ m: 1, minWidth: '90%' }}
                            />
                            {userErrors.userName && <small role="alert"><br></br>{userErrors.userName.message}</small>}
                        </td>
                        <td>
                            <TextField id="userEmail" 
                                key={'userEmail'}
                                // aria-invalid={!loginIsDirty ? undefined : userErrors.userEmail ? "true" : "false"}
                                {...userRegister("userEmail", {
                                    // required : t('message.common.error.text.email.input'),
                                    pattern : {
                                        value : emailRegEx,
                                        message : "invalid email address"
                                    }
                                })} 
                                // onChange={(e)=>{console.log(e.target.value)}}
                                defaultValue={''}
                                sx={{ m: 1, width: '80%' }}
                                onClick={()=>{setIsEmailCheck(false);}}
                                onChange={(event) => {setEmail(event.target.value); setIsEmailCheck(false);}}
                            />
                            <img src={`${process.env.PUBLIC_URL}/img/icon/circle.png`} style={{marginTop: '15px', cursor: 'pointer'}} onClick={()=>{dupleCheckEmail()}} />
                            {userErrors.userEmail && <small role="alert" style={{whiteSpace:"pre-wrap"}}><br></br>{userErrors.userEmail.message}</small>}
                        </td>
                        <td>
                            <TextField id="userContact" 
                                // aria-invalid={!userIsDirty ? undefined : userErrors.userContact ? "true" : "false"}
                                defaultValue={''}
                                key={'userContact'}
                                {...userRegister("userContact", {
                                    // required : t('message.common.error.text.manager.contact.input')
                                })} 
                                sx={{ m: 1, minWidth: '90%' }} 
                            />
                            {/* {userErrors.userContact && <small role="alert"><br></br>{userErrors.userContact.message}</small>} */}
                        </td>
                        {/* <td>
                            <TextField id="userCertificationNumber" 
                                defaultValue={''}
                                key={'userCertificationNumber'}
                                {...userRegister("userCertificationNumber", {
                                })} 
                                sx={{ m: 1, minWidth: '90%' }} 
                            />
                        </td> */}
                        {company.type === 'MNT'  && 
                        <td> - </td>
                        }
                        <td> - </td>
                        <td>
                            <Button type="submit" variant="contained" color="primary" 
                            // onClick={userHandleSubmit(userOnSubmit)}
                            >{t('message.common.btn.add')}</Button>
                        </td>
                    </tr>
                </tfoot>
                }
                </Table>
            </form>
            </TableContainer>
        </div>
        )
    }
}

export default CompanyModifyUser;